<beneficiary-personal-details-library [primaryData]="primaryData" (onDialogClose)="handleDialogClose()"
    style="width:100%">
</beneficiary-personal-details-library>